document.addEventListener('DOMContentLoaded', e => {

	if (document.querySelector('.tabs') != null) {
		document.querySelectorAll('.tabs-nav a').forEach((item) => {
			item.addEventListener('click', (evt) => {
				let ctx = evt.target.closest('.tabs');
				let newTab = evt.target.closest('li');
				let newTargetRef = evt.target.dataset.target;

				if (!newTab.classList.contains('--current')) {
					ctx.querySelector('li.--current').classList.remove('--current');
					newTab.classList.add('--current');

					let oldTarget = ctx.querySelector('div.--active');

					oldTarget.classList.remove('--show');
					setTimeout(() => {
						oldTarget.classList.remove('--active');
					}, 200);

					let newTarget = ctx.querySelector('div' + newTargetRef);

					newTarget.classList.add('--active');
					setTimeout(() => {
						newTarget.classList.add('--show');
						sleep(200).then(() => { ScrollTrigger.refresh(); });
					}, 100);

					let url = new URL(document.location);
					let urlParams = url.searchParams;
					let newTabId = newTargetRef.replace(/#/g, '');

					urlParams.set('tab', newTabId);
					url.search = urlParams.toString();

					let newUrl = url.toString();

				    if (typeof (history.pushState) != "undefined") {
				        const state = { tab: newTabId };

				        history.pushState(state, '', newUrl);
				    }
				}
			});
		});
	}
});
